import { Caption, Heading, Icon, Modal } from "@shopify/polaris"
import { LinkMinor } from "@shopify/polaris-icons"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import chatgptLogo from "../assets/chatgpt.svg"
import claudeLogo from "../assets/claude.svg"
import chatgptCreateApp from "../assets/chatgpt_createapp.png"
import chatgptCreateApp2 from "../assets/chatgpt_createapp_2.png"
import chatgptCreateApp3 from "../assets/chatgpt_createapp_3.png"
import claudeCreateApp from "../assets/claude_createapp.png"

const Step = ({ number, title, children }) => (
	<div style={{ display: "flex", gap: "0.75rem" }}>
		<div
			style={{
				flexShrink: 0,
				width: "1.75rem",
				height: "1.75rem",
				borderRadius: "100%",
				background: "#202223",
				color: "#fff",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				fontWeight: "bold",
				fontSize: "0.85rem",
			}}
		>
			{number}
		</div>
		<div style={{ flex: 1 }}>
			<Heading>{title}</Heading>
			{children}
		</div>
	</div>
)

const LinkButton = ({ href, children }) => (
	<a
		href={href}
		target="_blank"
		rel="noreferrer"
		style={{
			display: "block",
			width: "fit-content",
			margin: "auto",
			marginTop: "1rem",
			padding: "0.5rem 1rem",
			borderRadius: "0.5rem",
			border: "1px solid #ddd",
			background: "#fff",
			color: "#202223",
			fontWeight: "bold",
			textDecoration: "none",
			cursor: "pointer",
		}}
	>
		{children}
	</a>
)

const MCP_URL =
	import.meta.env.VITE_MCP_URL ||
	(typeof window !== "undefined" ? `${window.location.origin}/mcp` : "/mcp")

export const OPEN_MCP_INSTRUCTIONS_EVENT = "kopy:open-mcp-instructions"

export const openMCPInstructions = () => {
	if (typeof window !== "undefined") {
		window.dispatchEvent(new CustomEvent(OPEN_MCP_INSTRUCTIONS_EVENT))
	}
}

export const MCPInstructions = () => {
	const { t } = useTranslation()

	const [logoShown, setLogoShown] = useState("chatgpt")
	const [platform, setPlatform] = useState("chatgpt")
	const [modalIsOpen, setModalIsOpen] = useState(false)
	const [copied, setCopied] = useState(false)

	useEffect(() => {
		const interval = setInterval(() => {
			setLogoShown((prev) => (prev === "chatgpt" ? "claude" : "chatgpt"))
		}, 2000)
		return () => clearInterval(interval)
	}, [])

	useEffect(() => {
		const handleOpen = () => setModalIsOpen(true)
		window.addEventListener(OPEN_MCP_INSTRUCTIONS_EVENT, handleOpen)
		return () =>
			window.removeEventListener(OPEN_MCP_INSTRUCTIONS_EVENT, handleOpen)
	}, [])

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(MCP_URL)
			setCopied(true)
			setTimeout(() => setCopied(false), 2000)
		} catch {
			// Clipboard API unavailable (e.g. insecure context); ignore.
		}
	}
	return (
		<>
			<div
				style={{
					background: "#e7e7e7",
					borderRadius: "100%",
					padding: "0.4rem",
					position: "relative",
					cursor: "pointer",
				}}
				onClick={() => {
					setModalIsOpen(true)
				}}
			>
				<img
					style={{
						display: "block",
						width: "1.25rem",
						height: "1.25rem",
					}}
					src={logoShown === "chatgpt" ? chatgptLogo : claudeLogo}
					alt="logo"
				/>
			</div>

			<Modal
				title={
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.5rem",
						}}
					>
						{/* <img
							style={{
								width: "1.875rem",
								height: "1.875rem",
								borderRadius: "0.3125rem",
							}}
							src={kopyLogo}
						/> */}
						<span
							style={{
								display: "inline-flex",
								width: "1.25rem",
								height: "1.25rem",
							}}
						>
							<Icon source={LinkMinor} />
						</span>
						<span>{t("mcp_instructions.title")}</span>
					</div>
				}
				open={modalIsOpen}
				onClose={() => setModalIsOpen(false)}
			>
				<Modal.Section>
					<div
						style={{
							display: "flex",
							gap: "0.5rem",
							border: "1px solid #ddd",
							borderRadius: "9999px",
							padding: "0.25rem",
							width: "fit-content",
							margin: "0 auto 2rem",
						}}
					>
						<button
							style={{
								padding: "0.5rem 1rem",
								borderRadius: "9999px",
								border: "none",
								background:
									platform === "chatgpt"
										? "#f3f3f3"
										: "transparent",
								color: "#222",
								fontWeight: "bold",
								cursor: "pointer",
								display: "flex",
								alignItems: "center",
								gap: "0.5rem",
							}}
							onClick={() => setPlatform("chatgpt")}
						>
							<img
								src={chatgptLogo}
								style={{ width: "1.25rem", height: "1.25rem" }}
								alt="ChatGPT"
							/>
							ChatGPT
						</button>
						<button
							style={{
								padding: "0.5rem 1rem",
								borderRadius: "9999px",
								border: "none",
								background:
									platform === "claude"
										? "#f3f3f3"
										: "transparent",
								color: "#222",
								fontWeight: "bold",
								cursor: "pointer",
								display: "flex",
								alignItems: "center",
								gap: "0.5rem",
							}}
							onClick={() => setPlatform("claude")}
						>
							<img
								src={claudeLogo}
								style={{ width: "1.25rem", height: "1.25rem" }}
								alt="Claude"
							/>
							Claude
						</button>
					</div>

					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "1.5rem",
						}}
					>
						<Step
							number={1}
							title={t("mcp_instructions.step1_title")}
						>
							<Caption>
								{t("mcp_instructions.step1_description")}
							</Caption>
							<div
								style={{
									marginTop: "1rem",
									display: "flex",
									alignItems: "stretch",
									gap: "0.5rem",
								}}
							>
								<code
									style={{
										flex: 1,
										display: "flex",
										alignItems: "center",
										padding: "0.5rem 0.75rem",
										background: "#f6f6f7",
										border: "1px solid #ddd",
										borderRadius: "0.5rem",
										fontFamily: "monospace",
										fontSize: "0.85rem",
										color: "#202223",
										wordBreak: "break-all",
									}}
								>
									{MCP_URL}
								</code>
								<button
									type="button"
									onClick={handleCopy}
									style={{
										padding: "0.5rem 1rem",
										borderRadius: "0.5rem",
										border: "none",
										background: copied
											? "#108043"
											: "#202223",
										color: "#fff",
										fontWeight: "bold",
										cursor: "pointer",
										whiteSpace: "nowrap",
									}}
								>
									{copied
										? t("mcp_instructions.copied")
										: t("mcp_instructions.copy")}
								</button>
							</div>
						</Step>

						{platform === "chatgpt" ? (
							<>
								<Step
									number={2}
									title={t(
										"mcp_instructions.step2_title_chatgpt",
									)}
								>
									<Caption>
										{t(
											"mcp_instructions.step2_description_chatgpt",
										)}
									</Caption>
									<LinkButton href="https://chatgpt.com/apps#settings/Connectors/Advanced">
										{t(
											"mcp_instructions.open_chatgpt_settings",
										)}
									</LinkButton>
								</Step>

								<Step
									number={3}
									title={t(
										"mcp_instructions.step3_title_chatgpt",
									)}
								>
									<Caption>
										{t(
											"mcp_instructions.step3_description_chatgpt",
										)}
									</Caption>

									<div
										style={{
											marginTop: "1rem",
											display: "flex",
											alignItems: "center",
											gap: "1rem",
										}}
									>
										<img
											src={chatgptCreateApp}
											alt="ChatGPT Create App"
											style={{
												width: "40%",
												borderRadius: "0.5rem",
												border: "1px solid #ddd",
											}}
										/>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="1rem"
											height="1rem"
											viewBox="0 0 24 24"
										>
											<path
												fill="currentColor"
												d="M12.7 17.925q-.35.2-.625-.063T12 17.25L14.425 13H3q-.425 0-.713-.288T2 12q0-.425.288-.713T3 11h11.425L12 6.75q-.2-.35.075-.613t.625-.062l7.975 5.075q.475.3.475.85t-.475.85L12.7 17.925Z"
											></path>
										</svg>
										<img
											src={chatgptCreateApp2}
											alt="ChatGPT Create App 2"
											style={{
												width: "45%",
												borderRadius: "0.5rem",
												border: "1px solid #ddd",
											}}
										/>
									</div>
								</Step>

								<Step number={4} title="Last steps">
									<Caption>
										Click Sign in to authorize access and
										that&apos;s it! 🎉
									</Caption>

									<div
										style={{
											marginTop: "1rem",
											display: "flex",
											alignItems: "center",
											gap: "1rem",
										}}
									>
										<img
											src={chatgptCreateApp3}
											alt="ChatGPT Create App 3"
											style={{
												width: "80%",
												margin: "0 auto",
												borderRadius: "0.5rem",
												border: "1px solid #ddd",
											}}
										/>
									</div>
								</Step>
							</>
						) : (
							<>
								<Step
									number={2}
									title={t("mcp_instructions.step2_title")}
								>
									<Caption>
										{t(
											"mcp_instructions.step2_description",
										)}
									</Caption>
									<LinkButton href="https://claude.ai/customize/connectors?modal=add-custom-connector">
										{t(
											"mcp_instructions.open_claude_settings",
										)}
									</LinkButton>
								</Step>

								<Step
									number={3}
									title={t("mcp_instructions.step3_title")}
								>
									<Caption>
										{t(
											"mcp_instructions.step3_description",
										)}
									</Caption>
									<div
										style={{
											marginTop: "1rem",
											display: "flex",
											justifyContent: "center",
										}}
									>
										<img
											src={claudeCreateApp}
											alt="Claude Create App"
											style={{
												width: "60%",
												borderRadius: "0.5rem",
												border: "1px solid #ddd",
											}}
										/>
									</div>
								</Step>
							</>
						)}
					</div>
				</Modal.Section>
			</Modal>
		</>
	)
}
